
import { ArtistItem } from '@/dataTypes/types';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    artist: {
      type: Object as PropType<ArtistItem>,
      required: true,
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    role: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    emitDeleteArtist() {
      if (this.artist?.id) {
        this.$emit('delete', this.artist.id);
      }
    },
    moveUp() {
      if (this.artist?.id) {
        this.$emit('moveUp', this.artist.id);
      }
    },
    moveDown() {
      if (this.artist?.id) {
        this.$emit('moveDown', this.artist.id);
      }
    },
  },
});
